/**
 * Získá datum narození z rodného čísla.
 * @param birthNumber Rodné číslo (např. "920312/1234" nebo "0156121234")
 * @returns Datum narození ve formátu "yyyy-MM-dd", nebo `null`, pokud je RČ neplatné
 */
import { format } from 'date-fns';

export function extractBirthDateFromBirthNumber(birthNumber: string): string | null {
  const cleaned = birthNumber.replace('/', '');

  if (!/^\d{9,10}$/.test(cleaned)) return null;

  const year = Number.parseInt(cleaned.substring(0, 2), 10);
  let month = Number.parseInt(cleaned.substring(2, 4), 10);
  const day = Number.parseInt(cleaned.substring(4, 6), 10);

  if (month > 50) month -= 50;

  const currentYear = new Date().getFullYear() % 100;
  const fullYear = year > currentYear ? 1900 + year : 2000 + year;

  const date = new Date(fullYear, month - 1, day);

  if (date.getFullYear() !== fullYear || date.getMonth() !== month - 1 || date.getDate() !== day) {
    return null;
  }

  return format(date, 'yyyy-MM-dd');
}
